<div class="page-load-animation">
</div>
<router-outlet></router-outlet>